/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { createSantaMembersAPI, Section } from '@wix/members-area-commons-ts';

import Wix from './wix-sdk-polyfill';
import { parseGetParam } from './parse-get-param';
import { getConfig } from './config';

const MEMBERS_PAGE_ID = 'all_members';

export const getInstance = () => parseGetParam('instance'); // deprecated: use state.site

export const isEditor = () => parseGetParam('viewMode') === 'editor'; // deprecated: use state.site

export const isSeoViewMode = () => parseGetParam('viewMode') === 'viewer-seo'; // deprecated: use state.site

export const getViewMode = (search: any) => parseGetParam('viewMode', search); // deprecated: use state.site

export const getLocale = (search: any) => parseGetParam('locale', search) || 'en'; // deprecated: use state.site

// eslint-disable-next-line no-console
const logError = (type: string) => (err: any) => console.error(type, err);

const getAppDefIdBy = (verticalId: string) => _.get(getConfig(), `verticals.${verticalId}`);

const getSantaApi = () => {
  const santaMembersAppDefId = _.get(getConfig(), 'verticals.santaMembers') || '';
  return createSantaMembersAPI(santaMembersAppDefId, Wix);
};

export const navigateToMember = (memberId: string, memberSlug: string) =>
  getSantaApi().navigateToMember(memberId, memberSlug).catch(logError('navigateToMember'));

export const getNavigatableRoles = () => getSantaApi().getNavigatableRoles();

export const navigateToSection = (section: Section & { widgetId: string }) =>
  getSantaApi().navigateToSection(section).catch(logError('navigateToSection'));

export const navigateToMembersPage = (params: Partial<Record<'badgeId', string>> = {}) => {
  const queryParams = params as Record<string, string>;

  Wix.Utils.navigateToSection(
    {
      appDefinitionId: getAppDefIdBy('membersAllMembers'),
      sectionId: MEMBERS_PAGE_ID,
      queryParams,
    },
    (error: Error) => {
      logError('navigateToMembersPage')(error);
    },
  );
};

export const navigateToHomePage = () => {
  Wix.getSiteMap((pages: SitePage[]) => {
    const homePage = pages.find((page) => !!page.isHomePage);

    if (homePage) {
      Wix.navigateToPage(homePage.pageId);
    }
  });
};

export const openFFLightbox = async (data: {
  title: string;
  memberId: string;
  activeTab: 'following' | 'followers';
}) => {
  const membersAreaAPI: any = await getSantaApi().getAPI();
  return membersAreaAPI.openLightbox('following_followers_lightbox', data);
};
